// extracted by mini-css-extract-plugin
module.exports = {"date_wrapper":"date_wrapper--30vvR","breadcrumb":"breadcrumb--2JI8h"};